// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service from "../../proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt from "../../proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.js";
import * as Buhta_platformapis__Buhta_idp_v1_profile from "../../proto/platformapis/gen/buhta_idp_v1_profile.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Reader from "../../vendored/ocaml_protoc_plugin/reader.js";
import * as Ocaml_protoc_plugin__Writer from "../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const Invalid_payload = /* @__PURE__ */Caml_exceptions.create("Buhta_models.Models.Invalid_payload");

const binarytoa = ((b) => {
      return typeof btoa === "function"
        ? btoa(b)
        : Buffer.from(b, 'binary').toString('base64');
    }
);

const fromBase64 = ((str) => {
      const uint8arr = typeof atob === "function"
         ? atob(str).split('')
         : Buffer.from(str, 'base64').toString('binary').split('');
      return uint8arr.map(c => c.charCodeAt(0));
    }
);

const join = ((arr) => {
      return arr.join(' ');
    }
);

const UInt8Array = {
  fromBase64: fromBase64,
  join: join
};

const read_t = Atdgen_codec_decode.make(function (json) {
      let obj;
      try {
        obj = Curry._1(Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(fromBase64(json))));
      }
      catch (exn){
        throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
      }
      if (obj.TAG === /* Ok */0) {
        return obj._0;
      }
      throw new Caml_js_exceptions.MelangeError(Invalid_payload, {
                MEL_EXN_ID: Invalid_payload
              });
    });

const write_t = Atdgen_codec_encode.make(function (profile) {
      return binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile.to_proto, profile)));
    });

const IdentityProfile = {
  read_t: read_t,
  write_t: write_t
};

const read_t$1 = Atdgen_codec_decode.make(function (json) {
      let obj;
      try {
        obj = Curry._1(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(fromBase64(json))));
      }
      catch (exn){
        throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
      }
      if (obj.TAG === /* Ok */0) {
        return obj._0;
      }
      throw new Caml_js_exceptions.MelangeError(Invalid_payload, {
                MEL_EXN_ID: Invalid_payload
              });
    });

const write_t$1 = Atdgen_codec_encode.make(function (profile) {
      return binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt.to_proto, profile)));
    });

const Receipt = {
  read_t: read_t$1,
  write_t: write_t$1
};

const read_t$2 = Atdgen_codec_decode.make(function (json) {
      let obj;
      try {
        obj = Curry._1(Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service.Buhta.Kassa.V1alpha1.EtpOrder.from_proto, Ocaml_protoc_plugin__Reader.create(undefined, undefined, Stdlib__Bytes.to_string(fromBase64(json))));
      }
      catch (exn){
        throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
      }
      if (obj.TAG === /* Ok */0) {
        return obj._0;
      }
      throw new Caml_js_exceptions.MelangeError(Invalid_payload, {
                MEL_EXN_ID: Invalid_payload
              });
    });

const write_t$2 = Atdgen_codec_encode.make(function (profile) {
      return binarytoa(Ocaml_protoc_plugin__Writer.contents(Curry._1(Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service.Buhta.Kassa.V1alpha1.EtpOrder.to_proto, profile)));
    });

const EtpOrder = {
  read_t: read_t$2,
  write_t: write_t$2
};

export {
  Invalid_payload ,
  UInt8Array ,
  IdentityProfile ,
  Receipt ,
  EtpOrder ,
}
/* read_t Not a pure module */
